import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import { MdClose } from 'react-icons/md';
import { SpinnerLoader } from '../loaders';
import classes from './CustomModal.module.scss';

const CustomModal = (props) => {
    const {
        children,
        id,
        position,
        testId,
        contentLabel,
        isOpen,
        onRequestClose,
        onAfterOpen,
        isLoading,
        contentStyles,
    } = props;

    const positionObject = {
        top: position === 'top' ? '2rem' : '50%',
        transform: position === 'top' ? 'translateX(-50%)' : 'translate(-50%, -50%)',
    };

    const customStyles = {
        overlay: {
            backgroundColor: 'rgba(51, 51, 51, 0.28)',
            backdropFilter: 'blur(1px)',
        },
        content: {
            ...positionObject,
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            borderRadius: 'var(--border-radius-lg)',
            paddingTop: '1rem',
            maxWidth: '94%',
            ...contentStyles,
        },
    };

    Modal.setAppElement('#root');

    const renderChildren = () => {
        if (isLoading) {
            return (
                <div className={classes.Loader}>
                    <SpinnerLoader size="large" trackColor="#ccc" spinnerColor="#5667ff" />
                </div>
            );
        }
        return children;
    };

    useEffect(() => {
        // document.body.style.overflow = 'hidden';
        // return () => document.body.style.overflow = 'unset';
    }, [])
    
    return (
        <Modal
            isOpen={isOpen}
            onAfterOpen={onAfterOpen}
            onRequestClose={onRequestClose}
            style={customStyles}
            contentLabel={contentLabel}
            id={id}
            testId={testId}
            role="dialog"
            shouldCloseOnOverlayClick={false}
        >
            <div className={classes.CustomModal}>
                <button
                    className={classes.CustomModal__Close}
                    type="button"
                    onClick={onRequestClose}
                    title="close"
                >
                    <MdClose />
                </button>
                {renderChildren()}
            </div>
        </Modal>
    );
};

CustomModal.propTypes = {
    children: PropTypes.element,
    id: PropTypes.string,
    position: PropTypes.string,
    testId: PropTypes.string,
    contentLabel: PropTypes.string,
    isOpen: PropTypes.bool,
    onRequestClose: PropTypes.func,
    onAfterOpen: PropTypes.func,
    isLoading: PropTypes.bool,
    contentStyles: PropTypes.object,
};

export default CustomModal;
